import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IndicadorClienteInserirComponent } from './indicador-cliente-inserir.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: IndicadorClienteInserirComponent }
    ])],
    exports: [RouterModule]
})
export class IndicadorClienteInserirRoutingModule { }
